import { Refresh } from '@bb-ui/icons/dist/medium';
import { PrimaryButton } from '@bb-ui/react-library/dist/components/Button';
import { CircularProgress } from '@bb-ui/react-library';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface RefreshButtonProps {
  onRefresh: () => void;
  loading?: boolean;
  /** Button label. Defaults to global.refresh translation. */
  label?: string;
}

export const RefreshButton: React.FunctionComponent<RefreshButtonProps> = ({
  onRefresh,
  loading,
  label,
}) => {
  const { t } = useTranslation();

  return (
    <PrimaryButton
      startIcon={loading ? <CircularProgress ariaLabel="Refreshing" size="small" /> : <Refresh />}
      data-testid="refresh-button"
      onClick={onRefresh}
      disabled={loading}
    >
      {label ?? t('global.refresh')}
    </PrimaryButton>
  );
};
